import React from 'react';
import { Collapse, Row, Col } from 'antd';
import SEO from '../../components/SEO';
const { Panel } = Collapse;

const FAQ = () => {
    return (
        <div className="faqContainer">
            <SEO title="FAQ" description="One-Stop Transport & Finicial Solution" path="faq" />
            <Row justify="center" className="EasyleaseFaq">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h1 className="EasyleaseFaqTitle">FAQ</h1>
                    <p className="EasyleaseFaqDesc">Here are few common questions</p>

                    <Collapse defaultActiveKey={['1']}>
                        <Panel header="How does insurance works with Yoma Fleet Easy Lease? " key="1">
                            <p>
                                Comprehensive insurance coverage is included with all Yoma Fleet Easy Lease vehicle
                                contracts.{' '}
                            </p>
                            <p>The period that you are covered is linked exactly with your contract period.</p>
                            <p>
                                The non-deductible excess in the event of loss or damage, unless recovered from a third
                                party, is MMK 200,000.{' '}
                            </p>
                        </Panel>
                        <Panel header="Does Yoma Fleet provide a replacement vehicle if I have an accident?" key="2">
                            <p>
                                In the event of an accident where there has been no illegal use, Yoma Fleet will provide
                                a similar replacement vehicle whilst your vehicle is in the panel shop for repair.{' '}
                            </p>
                        </Panel>
                        <Panel header="What if I want to cancel or early return? " key="3">
                            <p>
                                You will be subject to a cancellation fee, which is 20% of the remaining payments on
                                your contract, with a minimum charge of one full month.{' '}
                            </p>
                            <p>For more detail on cancellations, just get in touch with our team. </p>
                        </Panel>
                        <Panel header="How does the approval process work? " key="4">
                            <p>
                                We ask you to complete our standard credit application form and supply scanned copies of
                                necessary documents. This will allow us to identify you and assess your ability to pay.
                                None of this information will be shared with any third parties.{' '}
                            </p>
                            <p>
                                To obtain a Yoma Fleet Easy lease vehicle you will need to pass the credit application
                                process. If you don’t pass, we won’t be able to move forward with your Easy Lease.{' '}
                            </p>
                            <p>
                                Still have questions? Please contact us by email at aung@yomafleet.com or via the chat
                                function on our website and we'll be delighted to help.{' '}
                            </p>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </div>
    );
};

export default FAQ;
